import { Component, inject, TemplateRef } from '@angular/core';
import { MatSortModule, Sort } from '@angular/material/sort';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OwnerOverviewComponent } from '../owner-overview/owner-overview.component';
import { BreadcrumbComponent } from '../../../elements/breadcrumb/breadcrumb.component';
import { Subscription } from 'rxjs';
import { HttpServiceService } from '../../../services/http-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from '../../../services/local-storage.service';
import { UserInfo } from '../../../models/users.model';
import { APP_CONSTANTS } from '../../../app.constants';
import { NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-owner-documents',
  imports: [OwnerOverviewComponent,MatSortModule, BreadcrumbComponent, NgIf, NgFor, FormsModule],
  templateUrl: './owner-documents.component.html',
  styleUrl: './owner-documents.component.css'
})
export class OwnerDocumentsComponent {
  breadcrumbList : any;
  allData :  any = [
    {
      'document_comment' : 'document_comment',
      'category' : 'category',
      'doc_type' : 'doc_type',
      'property_name' : 'property_name',
      'permission' : 'permission',
      'created' : 'created'
    }
  ];
  page: any = 1;
  totalRows: number = 5;
  totalPage: any = 0;
  userId : string = '';
  private modalService= inject(NgbModal);
  private localStorageService = inject(LocalStorageService);
  private getUserDetailsSubscription? : Subscription;
  private routeSubscription?: Subscription;
  private getAllDocumentsSubscription?: Subscription;
  private getBillImagesSubscription?:Subscription;
  ownerDocuments : any;
  userInfo : any;
  profileDetails : any;
  userDetails : any;
  userProperties : any = [];
  choosenProperty : string = '';
  addProperty? : string;

  constructor(private httpService : HttpServiceService, private route: ActivatedRoute, private router: Router){
    this.routeSubscription =  this.route.paramMap.subscribe(params => {
      this.userId = params.get('id') ?? "";
      let userType = params.get('type') ?? "";
      this.breadcrumbList = { 
        breadcrumb_path: userType == "owner" ? "Owners" : "Tenants",
        currentURL: 'Documents',
        breadcrumb_url : '/admin/'+ (userType == "owner" ? "owners" : "tenants") 
      }
    });
  }

  ngOnInit(){
    this.userInfo = this.localStorageService.getItem("userInfo") as UserInfo;
  }

  goBackToList(event : any){    
    this.router.navigate([this.breadcrumbList.breadcrumb_url]);
  }

  sortData(sort: Sort) {
    const data = this.allData.slice();
    if (!sort.active || sort.direction === '') {
      this.allData = data;
      return;
    }

    this.allData = data.sort((a : any, b : any) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'document_comment': return compare(a.document_comment, b.document_comment, isAsc);
        case 'category': return compare(a.category, b.category, isAsc);
        case 'doc_type': return compare(a.doc_type, b.doc_type, isAsc);
        case 'property_name': return compare(a.property_name, b.property_name, isAsc);
        case 'permission': return compare(a.permission, b.permission, isAsc);       
        case 'created': return compare(a.created, b.created, isAsc);
        default: return 0;
      }
    });
    //this.allData = this.this.allData, this.page, this.totalRows);
  }

  openCenter(content: TemplateRef<any>) {
    this.modalService.open(content, { centered: true,  backdrop: 'static' });
  }
  
  closeModal() {
    this.modalService.dismissAll();
  }

  getUserDetails(data : any){
    this.userDetails = data;
    this.userProperties = data["properties"] ?? [];
    let defaultPropertyId = this.userProperties?.length ? this.userProperties[0].uid : "";
    if(defaultPropertyId) {
      this.choosenProperty = defaultPropertyId;
      this.getAllDocuments(defaultPropertyId);
    }
  }

  getPropertyDocuments(){    
    this.getAllDocuments(this.choosenProperty);
  }

  getAllDocuments(propertyId : string){
    this.getAllDocumentsSubscription = this.httpService.getAllPropertyDocuments(propertyId).subscribe({
      next : (response) => {
        this.ownerDocuments = response.data;
      }
    })
  }

  viewImage(imageUrl : string){
    this.getBillImagesSubscription = this.httpService.getBillImages(imageUrl).subscribe({
      next : (response) => {
        window.open(response.data["url"] , "_blank");
      }
    })
  }

  isDocumentVisible(data : any) : boolean {
    if(this.userInfo["role_identifier"] == APP_CONSTANTS.USER_ROLES.OWNER && data.owner_visible){
      return true;
    }else if(this.userInfo["role_identifier"] == APP_CONSTANTS.USER_ROLES.TENANT && data.tenant_visible){
      return true;
    }
    return false;
  }

  ngOnDestroy(){
    this.getUserDetailsSubscription?.unsubscribe();
    this.routeSubscription?.unsubscribe();
    this.getAllDocumentsSubscription?.unsubscribe();
    this.getBillImagesSubscription?.unsubscribe();
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
